import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { SERVER_API_URL } from 'src/app/app.constants';

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  // COUNTRY_URL_BEGIN = 'https://restcountries.eu/rest/v2/alpha/';
  // COUNTRY_URL_END = '?fields=name;capital;currencies;population;flag;area';

  COUNTRY_API_BASE_URL= SERVER_API_URL+'countries/metadata/';

  constructor(
    private http: HttpClient
  ) {}

  getCountryExternalInformations(countryCode: string) : Observable<any> {
    if (countryCode === 'UK') {
      countryCode = 'GB'
    }
    return this.http.get<any>(this.COUNTRY_API_BASE_URL+countryCode);
  }
}
